import { Injectable } from '@angular/core';

interface unsavedData {
  component: string,
  data: any[],
}

@Injectable()
export class DataTrackingService {

  unsavedDataList = [];
  constructor() { }

  addChangeDetails(component, event) {
      if(!this.unsavedDataList.includes(component) && component != undefined) {
        this.unsavedDataList.push(component);
      }
  }

  removeUnsavedItem(component) {
    this.unsavedDataList = this.unsavedDataList.filter(item => item != component);
  }

  removeAllUnsavedItem() {
    this.unsavedDataList = [];
  }

}
